import React, { FC, useEffect, useState } from 'react'
import Modal from 'components/Modal'
import { useNavigate } from 'react-router-dom'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import { ActivatedUser } from '../ActivatedUser'
import { ModalPWA } from 'componentsPWA/ModalPWA'
import { CloseIconButtonPWA } from 'componentsPWA/CloseIconButtonPWA'

import LogoIcon from 'sources/images/companyIconGradient.svg'
import defaultUserPhoto from 'sources/images/defaultUser.svg'

import { createPostFileType, getDate, getTime } from 'utils'
import { IFollowing } from 'models'

import styles from './styles.module.scss'
import cn from 'classnames'

interface IProps {
  isOpen: boolean
  setIsOpen: (value: boolean) => void
  userId?: string
  publicationId?: number
  type: BackersType
  modePWA?: boolean
}

enum BackersType {
  profile,
  posts,
  singlePost,
  followers,
  videos
}

interface IBacker {
  Activated: boolean
  BackAmount: number
  DateTime: string
  FirstName: string
  ImageLink: string
  LastName: string
  NickName: string
  OpenSeaLink: string | null
  UserId: string
}

//Resize
export const BackersModal: FC<IProps> = observer((
  { isOpen, setIsOpen, userId, publicationId, type, modePWA }) => {
  const navigate = useNavigate()
  const { donate, loading, following, profile } = useStore()
  const [backers, setBackers] = useState<IBacker[]>([])

  useEffect(() => {
    isOpen && getBackers()
  }, [isOpen])

  const getBackers = async () => {
    try {
      if (type === 3 && userId) {
        const response: IFollowing[] = await following.GetFollowersList(userId)
        const followersData = response.map(item => {
          return {
            Activated: item.Activated,
            BackAmount: 0,
            DateTime: '',
            FirstName: item.FirstName,
            ImageLink: item.ImageLink,
            LastName: item.LastName,
            NickName: item.NickName,
            OpenSeaLink: item.OpenSeaLink,
            UserId: item.Id
          }
        })
        setBackers(followersData)
      } else {
        const response = await donate.getBackers(1, { type: type, userId, publicationId })
        setBackers(response)
      }
    } catch (e) {

    } finally {
      loading.setLoading(false)
    }
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  const redirectToProfile = (nickName: string) => {
    setIsOpen(false)
    navigate(`/user/${nickName}`)
  }

  const content = (
    <div className={cn(styles.container, {
      [styles.containerPWA]: modePWA
    })}>
      {!modePWA ? <div className={styles.title}>{type === 3 ? 'Followers' : 'Backers'}</div> : null}
      <div className={styles.backersList}>
        {backers.map((item, idx) => (
          <div className={styles.beckerInfo} key={idx}>
            <div className={styles.userInfo}
                 onClick={() => redirectToProfile(item.NickName)}>
              <img src={item.ImageLink ? item.ImageLink : defaultUserPhoto}
                   alt="avatar" className={styles.avatar}/>
              <div className={styles.userNameBox}>
                <div className={styles.userName}>{`${item.FirstName} ${item.LastName}`}</div>
                <div className={styles.nickNameBlock}>
                  <div className={styles.nickname}>{item.NickName ? `@${item.NickName}` : ''}</div>
                  <ActivatedUser activated={item.Activated}/>
                </div>
              </div>
            </div>

            {type !== 3
              ? <div className={styles.dataAmountInfo}>
                <div className={styles.countBox}>
                  <img src={LogoIcon} alt=""/>{item.BackAmount}
                </div>
                <div className={styles.date}>
                  <div className={styles.day}>{getDate(item.DateTime)}</div>
                  <div className={styles.time}>{getTime(item.DateTime)}</div>
                </div>
              </div> : null}

          </div>
        ))}
      </div>
    </div>
  )

  return (
    <>{modePWA
      ? <ModalPWA open={isOpen}
                  onClose={closeModal}
                  dialogMode
                  fullScreen
                  disableOutsideClick
                  dialogContentTextSX={{ padding: 0 }}
                  dialogTitle={<div className={styles.modalTitlePWA}>
                    <CloseIconButtonPWA onClose={closeModal}/>
                    <div className={styles.title}><span>{type === 3 ? 'Followers' : 'Backers'}</span></div>
                  </div>}
      >
        {content}
      </ModalPWA>
      : <Modal
        size="responsiveMedium"
        onClose={closeModal}
        open={isOpen}
        closeButton={true}
      >
        {content}
      </Modal>}
    </>
  )
})
